import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/natoma/node_modules/@mui/material/LinearProgress/LinearProgress.js");
;
import(/* webpackMode: "eager" */ "/opt/natoma/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/natoma/packages/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/natoma/packages/frontend/src/components/snippets/DatadogSnippet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/natoma/packages/frontend/src/components/ThemeRegistry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnvironmentProvider"] */ "/opt/natoma/packages/frontend/src/providers/Environment.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoggingProvider"] */ "/opt/natoma/packages/frontend/src/providers/Logging.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/opt/natoma/packages/frontend/src/providers/Toast.tsx");
